import {ADD_PRODUCT, DECREASE_PRODUCT_QTY, INCREASE_PRODUCT_QTY, RESTORE_PRODUCT_QTY} from "./actionTypes";
import initialState from "./initialState";

const productReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_PRODUCT:
            return [...state, action.payload];

        case INCREASE_PRODUCT_QTY:
            const itemToIncreaseQty = state.find(p => p.id === action.payload);
            if (itemToIncreaseQty !== undefined) {
                const others = state.filter(p => p.id !== itemToIncreaseQty.id);
                return [...others, {...itemToIncreaseQty, quantity: itemToIncreaseQty.quantity + 1}];
            }
            return;

        case DECREASE_PRODUCT_QTY:
            const itemToDecreaseQty = state.find(p => p.id === action.payload);
            if (itemToDecreaseQty !== undefined) {
                const others = state.filter(p => p.id !== itemToDecreaseQty.id);
                return [...others, {...itemToDecreaseQty, quantity: itemToDecreaseQty.quantity - 1}];
            }
            return;
            
        case RESTORE_PRODUCT_QTY:
            const itemToRestoreQty = state.find(p => p.id === action.payload.id);
            if (itemToRestoreQty !== undefined) {
                const others = state.filter(p => p.id !== itemToRestoreQty.id);
                return [...others, {...itemToRestoreQty, quantity: itemToRestoreQty.quantity + action.payload.quantity}];
            }
            return;

        default:
            return state;
    }
};

export default productReducer;
